import { lazyModuleMethod } from '@/helpers/lazyModuleMethod'

export const mailing = {
  fetchMailingList: lazyModuleMethod(
    () => import('./fetchMailingList'),
    'default'
  ),
  fetchMailingItem: lazyModuleMethod(
    () => import('./fetchMailingItem'),
    'default'
  ),
  createMailingItem: lazyModuleMethod(
    () => import('./createMailingItem'),
    'default'
  ),
  updateMailingItem: lazyModuleMethod(
    () => import('./updateMailingItem'),
    'default'
  ),
  deleteMailingArticle: lazyModuleMethod(
    () => import('./deleteMailingArticle'),
    'default'
  ),
  createMailingArticle: lazyModuleMethod(
    () => import('./createMailingArticle'),
    'default'
  ),
  updateMailingArticle: lazyModuleMethod(
    () => import('./updateMailingArticle'),
    'default'
  ),
  fetchMailingFormArticles: lazyModuleMethod(
    () => import('./fetchMailingFormArticles'),
    'default'
  ),
  deleteMailingItem: lazyModuleMethod(
    () => import('./deleteMailingItem'),
    'default'
  ),
  fetchSendsaySegment: lazyModuleMethod(
    () => import('./fetchSendsaySegment'),
    'default'
  ),
  fetchMailingPreview: lazyModuleMethod(
    () => import('./fetchMailingPreview'),
    'default'
  ),
  postMailingPreview: lazyModuleMethod(
    () => import('./postMailingPreview'),
    'default'
  ),
}
